import { format, parseISO } from 'date-fns';

const numberOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
};

const defaultLocalization = {
    number(input) {
        const result = input.toLocaleString('da-DK', numberOptions);
        return result;
    },
    formatDate(input) {
        const result = format(input, 'dd-MM-yyyy');
        return result;
    },
    dimensionsUnit: () => 'CM',
    weightUnit: () => 'KG'
};

const usLocalization = {
    number(input) {
        const result = input.toLocaleString('en-US', numberOptions);
        return result;
    },
    formatDate(input) {
        const result = format(input, 'MM/dd/yyyy');
        return result;
    },
    dimensionsUnit: () => 'IN',
    weightUnit: () => 'LB'
};

export default {
    methods: {
        localization() {
            if (this.$store.state.core.shipmentSystem === 'YOYOUnitedStates') {
                return usLocalization;
            }

            return defaultLocalization;
        },

        localizedNumber(input) {
            const number = parseFloat(input);

            const locale = this.localization();
            const result = locale.number(number);
            return result;
        },
        formatDate(input) {
            const locale = this.localization();
            const result = locale.formatDate(input);
            return result;
        },
        formatDateTimeOffset(input) {
            const date = parseISO(input);
            const result = format(date, 'dd-MM-yyyy HH:mm:ss');
            return result;
        },
        dimensionsUnit() {
            const locale = this.localization();
            const result = locale.dimensionsUnit();
            return result;
        },
        weightUnit() {
            const locale = this.localization();
            const result = locale.weightUnit();
            return result;
        }
    }
};
